import { cn } from '@/lib/utils';

type Severity = 'success' | 'error' | 'warning' | 'info';

const SEVERITY_CLASSES: Record<Severity, string> = {
  success: 'bg-emerald-light border-emerald/20 text-emerald-ink',
  error: 'bg-ruby-light border-ruby/20 text-ruby',
  warning: 'bg-amber-light border-amber/20 text-amber',
  info: 'bg-cobalt-light border-cobalt/20 text-cobalt',
};

function DefaultAlert({
  severity = 'info',
  alertTitle,
  alertDescription,
  className,
}: {
  severity?: Severity;
  alertTitle?: string;
  alertDescription?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'rounded-lg border px-4 py-3 text-sm',
        SEVERITY_CLASSES[severity],
        className
      )}
    >
      {alertTitle && <p className="font-semibold">{alertTitle}</p>}
      {alertDescription && (
        <p className="mt-0.5 opacity-90">{alertDescription}</p>
      )}
    </div>
  );
}

export default DefaultAlert;
